import React from 'react';
import { useSelector } from 'react-redux';
import { createBrowserRouter, Navigate, Outlet, RouterProvider, useParams } from 'react-router-dom';

import SignedOutLayout from '../view/layout/signed_out_layout';
import SignInPage from '../view/main/sign_in';
import {
    ROUTE_ADVERTISEMENTS,
    ROUTE_AUTOMATIC_COUPON_SETTING_FORMS,
    ROUTE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING_FORMS,
    ROUTE_COUPON_FORMS,
    ROUTE_COUPON_FORMS_NEW,
    ROUTE_COUPONS,
    ROUTE_CUSTOMER,
    ROUTE_CUSTOMER_POD_ORDER_NEW,
    ROUTE_CUSTOMER_THEFT_REGISTRY_NEW,
    ROUTE_CUSTOMER_THEFT_REGISTRY_VIEW,
    ROUTE_CUSTOMERS,
    ROUTE_DELIVERY_NOTIFICATIONS,
    ROUTE_DELIVERY_NOTIFICATIONS_EDIT,
    ROUTE_DELIVERY_NOTIFICATIONS_NEW,
    ROUTE_EMPLOYER,
    ROUTE_EMPLOYERS,
    ROUTE_EVENT_REGISTER_NEW,
    ROUTE_EXPIRATION_PROMOTIONS,
    ROUTE_EXPIRATION_PROMOTIONS_DETAILS,
    ROUTE_FOOD_PARTNER_FORMS,
    ROUTE_FOOD_PARTNER_FORMS_NEW,
    ROUTE_FOOD_PARTNER_ORDERS,
    ROUTE_FOOD_PARTNER_ORDERS_EDIT,
    ROUTE_FOOD_PARTNER_ORDERS_NEW,
    ROUTE_FOOD_PARTNER_ORDERS_VIEW,
    ROUTE_FOOD_PARTNERS,
    ROUTE_INCORRECT_EMAILS,
    ROUTE_INDOOR_PARTNER_EDIT,
    ROUTE_INDOOR_PARTNER_NEW,
    ROUTE_NOTIFICATIONS,
    ROUTE_NOTIFICATIONS_NEW,
    ROUTE_POD_ADVERTISEMENTS,
    ROUTE_POD_SALES_DISTRIBUTION,
    GET_ROUTE_POD_SALES_DISTRIBUTION,
    ROUTE_LEGACY_SALES,
    ROUTE_LEGACY_POD_SALES,
    ROUTE_PODS,
    ROUTE_PODS_EDIT,
    ROUTE_PODS_NEW,
    ROUTE_PRICE_LIST,
    ROUTE_PRICE_LISTS,
    ROUTE_PRICE_LISTS_EDIT,
    ROUTE_PRICE_LISTS_NEW,
    ROUTE_PRODUCER_FORMS,
    ROUTE_PRODUCER_FORMS_NEW,
    ROUTE_PRODUCERS,
    ROUTE_PRODUCT_FORMS,
    ROUTE_PRODUCT_FORMS_NEW,
    ROUTE_PRODUCT_PROMOTIONS,
    ROUTE_PRODUCT_PROMOTIONS_DETAILS,
    ROUTE_PRODUCTS,
    ROUTE_PROMOTION_CAMPAIGNS,
    ROUTE_PROMOTION_CAMPAIGNS_FORMS,
    ROUTE_PROMOTION_CAMPAIGNS_FORMS_NEW,
    ROUTE_RESERVATIONS,
    ROUTE_SALES_ANALYSIS,
    ROUTE_SIGN_IN,
    ROUTE_STORE_PROMOTION_SETTINGS,
    ROUTE_SUPPLIERS,
    ROUTE_SUPPLIERS_EDIT,
    ROUTE_SUPPLIERS_NEW,
    ROUTE_THEFT_REGISTRIES,
    ROUTE_WAREHOUSE_DOCUMENT_FORM,
    ROUTE_WAREHOUSE_DOCUMENT_VIEW,
    ROUTE_WAREHOUSE_DOCUMENTS,
    ROUTE_WAREHOUSE_REPORTS,
    ROUTE_WAREHOUSE_STOCKS,
    ROUTE_WAREHOUSE_STOCK
} from './constants';
import { isSignedIn } from './utils/session_utils';
import { getTokenState } from '../features/authorization/get_token';
import SignedInLayout from '../view/layout/signed_in_layout';
import ProductsPage from '../view/main/products';
import ProductFormsPage from '../view/main/products/product_forms';
import ExpirationPromotionsDetailsPage from '../view/main/promotions/expiration_promotions/details';
import NotificationsPage from '../view/main/notifications';
import PriceListsPage from '../view/main/price_lists';
import SalesAnalysisPage from '../view/main/sales_analysis';
import WarehouseStocksPage from '../view/main/warehouse/stocks';
import WarehouseStockPage from '../view/main/warehouse/stocks/details';
import PodSalesDistributionPage from '../view/main/pods/sales_distribution';
import CouponsPage from '../view/main/coupons';
import CouponFormsPage from '../view/main/coupons/coupon_forms';
import NotificationPage from '../view/main/notifications/form';
import AutomaticCouponSettingFormsPage from '../view/main/coupons/automatic_coupon_setting_forms';
import AdvertisementsPage from '../view/main/advertisments';
import AdvertisementDisplayOrderForm from '../view/main/advertisments/advertisement_forms';
import FoodPartnersPage from '../view/main/food_partners';
import FoodPartnerPage from '../view/main/food_partners/form';
import EmployersPage from '../view/main/employers';
import EmployerPage from '../view/main/employers/employer';
import ReservationsPage from '../view/main/reservations';
import WarehouseDocumentsPage from '../view/main/warehouse/documents';
import WarehouseDocumentDetailsPage from '../view/main/warehouse/documents/details';
import GenerateWarehouseDocumentForm from '../view/main/warehouse/documents/generate_forms';
import FoodPartnerOrdersPage from '../view/main/warehouse/food_partner_orders';
import FoodPartnerOrderCreateForm from '../view/main/warehouse/food_partner_orders/form/create';
import FoodPartnerOrderEditForm from '../view/main/warehouse/food_partner_orders/form/edit';
import AutomaticExpirationPromotionSettingFormsPage from '../view/main/promotions/expiration_promotions/form/automatic_expiration_promotion_setting_forms';
import ProducersPage from '../view/main/producers';
import ProducerPage from '../view/main/producers/form';
import PromotionCampaignFormsPage from '../view/main/promotions/promotion_campaigns/forms';
import SuppliersPage from '../view/main/suppliers';
import SupplierForm from '../view/main/suppliers/form';
import DeliveryNotificationsPage from '../view/main/delivery_notifications';
import DeliveryNotificationForm from '../view/main/delivery_notifications/form';
import ProductPromotionsPage from '../view/main/promotions/product_promotions';
import ProductPromotionsDetailsPage from '../view/main/promotions/product_promotions/details';
import ExpirationPromotionsPage from '../view/main/promotions/expiration_promotions';
import PromotionCampaignsPage from '../view/main/promotions/promotion_campaigns';
import WarehouseReportsPage from '../view/main/warehouse/reports';
import PodsPage from '../view/main/pods';
import PodForm from '../view/main/pods/form/pod_form';
import IndoorPartnerForm from '../view/main/pods/form/indoor_partner_form';
import CustomersPage from '../view/main/customers';
import CustomerPage from '../view/main/customers/customer';
import TheftRegistryForm from '../view/main/customers/customer/theft_tegistry/create';
import TheftRegistryDetailsPage from '../view/main/customers/customer/theft_tegistry/details';
import TheftRegistriesPage from '../view/main/theft_registries';
import IncorrectEmailsPage from '../view/main/incorrect_emails';
import StorePromotionSettingsPage from '../view/main/promotions/store_promotion_settings';
import EventRegisterForm from '../view/main/pods/form/event_register_form';
import OrderForm from '../view/main/customers/customer/tabs/transactions/form';
import PriceListForm from '../view/main/price_lists/form';
import PriceListPage from '../view/main/price_lists/price_list';

const RequireAuth = () => {
    const getToken = useSelector(getTokenState);

    if (!isSignedIn(getToken)) {
        return <Navigate to={ ROUTE_SIGN_IN } replace/>;
    }

    return (
        <SignedInLayout>
            <Outlet/>
        </SignedInLayout>
    );
};

const LegacyPodSalesRedirect = () => {
    const { podId } = useParams();

    return <Navigate to={ GET_ROUTE_POD_SALES_DISTRIBUTION(podId) } replace/>;
};

const RequireGuest = () => {
    const getToken = useSelector(getTokenState);

    if (isSignedIn(getToken)) {
        return <Navigate to={ ROUTE_SALES_ANALYSIS } replace/>;
    }

    return (
        <SignedOutLayout>
            <Outlet/>
        </SignedOutLayout>
    );
};

const router = createBrowserRouter([
    {
        element: <RequireAuth/>,
        children: [
            { path: ROUTE_SALES_ANALYSIS, element: <SalesAnalysisPage/> },
            { path: ROUTE_PRODUCTS, element: <ProductsPage/> },
            { path: ROUTE_PRODUCT_FORMS, element: <ProductFormsPage/> },
            { path: ROUTE_PRODUCT_FORMS_NEW, element: <ProductFormsPage/> },
            { path: ROUTE_PODS, element: <PodsPage/> },
            { path: ROUTE_PODS_NEW, element: <PodForm/> },
            { path: ROUTE_PODS_EDIT, element: <PodForm/> },
            { path: ROUTE_INDOOR_PARTNER_NEW, element: <IndoorPartnerForm/> },
            { path: ROUTE_INDOOR_PARTNER_EDIT, element: <IndoorPartnerForm/> },
            { path: ROUTE_EVENT_REGISTER_NEW, element: <EventRegisterForm/> },
            { path: ROUTE_PRODUCERS, element: <ProducersPage/> },
            { path: ROUTE_PRODUCER_FORMS, element: <ProducerPage/> },
            { path: ROUTE_PRODUCER_FORMS_NEW, element: <ProducerPage/> },
            { path: ROUTE_FOOD_PARTNERS, element: <FoodPartnersPage/> },
            { path: ROUTE_FOOD_PARTNER_FORMS, element: <FoodPartnerPage/> },
            { path: ROUTE_FOOD_PARTNER_FORMS_NEW, element: <FoodPartnerPage/> },
            { path: ROUTE_EMPLOYERS, element: <EmployersPage/> },
            { path: ROUTE_EMPLOYER, element: <EmployerPage/> },
            { path: ROUTE_SUPPLIERS, element: <SuppliersPage/> },
            { path: ROUTE_SUPPLIERS_NEW, element: <SupplierForm/> },
            { path: ROUTE_SUPPLIERS_EDIT, element: <SupplierForm/> },
            { path: ROUTE_CUSTOMERS, element: <CustomersPage/> },
            { path: ROUTE_CUSTOMER, element: <CustomerPage/> },
            { path: ROUTE_THEFT_REGISTRIES, element: <TheftRegistriesPage/> },
            { path: ROUTE_CUSTOMER_THEFT_REGISTRY_NEW, element: <TheftRegistryForm/> },
            { path: ROUTE_CUSTOMER_THEFT_REGISTRY_VIEW, element: <TheftRegistryDetailsPage/> },
            { path: ROUTE_CUSTOMER_POD_ORDER_NEW, element: <OrderForm/> },
            { path: ROUTE_INCORRECT_EMAILS, element: <IncorrectEmailsPage/> },
            { path: ROUTE_POD_SALES_DISTRIBUTION, element: <PodSalesDistributionPage/> },
            { path: ROUTE_LEGACY_SALES, element: <Navigate to={ ROUTE_PODS } replace/> },
            { path: ROUTE_LEGACY_POD_SALES, element: <LegacyPodSalesRedirect/> },
            { path: ROUTE_RESERVATIONS, element: <ReservationsPage/> },
            { path: ROUTE_PRODUCT_PROMOTIONS, element: <ProductPromotionsPage/> },
            { path: ROUTE_PRODUCT_PROMOTIONS_DETAILS, element: <ProductPromotionsDetailsPage/> },
            { path: ROUTE_EXPIRATION_PROMOTIONS, element: <ExpirationPromotionsPage/> },
            { path: ROUTE_EXPIRATION_PROMOTIONS_DETAILS, element: <ExpirationPromotionsDetailsPage/> },
            { path: ROUTE_AUTOMATIC_EXPIRATION_PROMOTION_SETTING_FORMS, element: <AutomaticExpirationPromotionSettingFormsPage/> },
            { path: ROUTE_STORE_PROMOTION_SETTINGS, element: <StorePromotionSettingsPage/> },
            { path: ROUTE_PROMOTION_CAMPAIGNS, element: <PromotionCampaignsPage/> },
            { path: ROUTE_PROMOTION_CAMPAIGNS_FORMS, element: <PromotionCampaignFormsPage/> },
            { path: ROUTE_PROMOTION_CAMPAIGNS_FORMS_NEW, element: <PromotionCampaignFormsPage/> },
            { path: ROUTE_NOTIFICATIONS, element: <NotificationsPage/> },
            { path: ROUTE_NOTIFICATIONS_NEW, element: <NotificationPage/> },
            { path: ROUTE_PRICE_LISTS, element: <PriceListsPage/> },
            { path: ROUTE_PRICE_LISTS_NEW, element: <PriceListForm/> },
            { path: ROUTE_PRICE_LISTS_EDIT, element: <PriceListForm/> },
            { path: ROUTE_PRICE_LIST, element: <PriceListPage/> },
            { path: ROUTE_COUPONS, element: <CouponsPage/> },
            { path: ROUTE_COUPON_FORMS, element: <CouponFormsPage/> },
            { path: ROUTE_COUPON_FORMS_NEW, element: <CouponFormsPage/> },
            { path: ROUTE_AUTOMATIC_COUPON_SETTING_FORMS, element: <AutomaticCouponSettingFormsPage/> },
            { path: ROUTE_ADVERTISEMENTS, element: <AdvertisementsPage/> },
            { path: ROUTE_POD_ADVERTISEMENTS, element: <AdvertisementDisplayOrderForm/> },
            { path: ROUTE_WAREHOUSE_DOCUMENTS, element: <WarehouseDocumentsPage/> },
            { path: ROUTE_WAREHOUSE_DOCUMENT_VIEW, element: <WarehouseDocumentDetailsPage/> },
            { path: ROUTE_WAREHOUSE_DOCUMENT_FORM, element: <GenerateWarehouseDocumentForm/> },
            { path: ROUTE_FOOD_PARTNER_ORDERS, element: <FoodPartnerOrdersPage/> },
            { path: ROUTE_FOOD_PARTNER_ORDERS_NEW, element: <FoodPartnerOrderCreateForm/> },
            { path: ROUTE_FOOD_PARTNER_ORDERS_EDIT, element: <FoodPartnerOrderEditForm/> },
            { path: ROUTE_FOOD_PARTNER_ORDERS_VIEW, element: <FoodPartnerOrderEditForm/> },
            { path: ROUTE_WAREHOUSE_REPORTS, element: <WarehouseReportsPage/> },
            { path: ROUTE_WAREHOUSE_STOCKS, element: <WarehouseStocksPage/> },
            { path: ROUTE_WAREHOUSE_STOCK, element: <WarehouseStockPage/> },
            { path: ROUTE_DELIVERY_NOTIFICATIONS, element: <DeliveryNotificationsPage/> },
            { path: ROUTE_DELIVERY_NOTIFICATIONS_NEW, element: <DeliveryNotificationForm/> },
            { path: ROUTE_DELIVERY_NOTIFICATIONS_EDIT, element: <DeliveryNotificationForm/> },

            { path: '*', element: <Navigate to={ ROUTE_SIGN_IN } replace/> }
        ]
    },
    {
        element: <RequireGuest/>,
        children: [
            { path: ROUTE_SIGN_IN, element: <SignInPage/> },
            { path: '*', element: <Navigate to={ ROUTE_SIGN_IN } replace/> }
        ]
    }
]);

const Routing = () => {
    return <RouterProvider router={ router }/>;
};

export default Routing;
